const AUTO_DETECT_ZIP_CODE_SESSION_STORAGE_KEY = 'STATDEMANDBASE';
const AUTO_DETECT_ZIP_CODE_PROPERTY_NAME = 'registry_zip_code';
const USER_ZIP_CODE_LOCAL_STORAGE_KEY = 'userZipCode';
let isGeolocated = false;
export function isZipCodeGeolocated() {
  return isGeolocated;
}
export function isZipCodeValid(pattern, code) {
  return pattern.test(code);
}
export function removeZipCodeFromStorage() {
  window.localStorage.removeItem(USER_ZIP_CODE_LOCAL_STORAGE_KEY);
}
export function saveZipCodeToStorage(countryLanguageCode, code) {
  const value = {};
  value[countryLanguageCode] = code;
  window.localStorage.setItem(USER_ZIP_CODE_LOCAL_STORAGE_KEY, JSON.stringify(value));
}
function getValueFromStorage(storage, key, namespace) {
  const storageObj = storage.getItem(key);
  try {
    const parsedObj = JSON.parse(storageObj);
    const value = parsedObj[namespace];
    return value ? value.toString() : null;
  }
  catch (e) {
    return null;
  }
}
function restoreZIPCodeValue(countryLanguageCode, length) {
  const localeZIPCode = getValueFromStorage(window.localStorage, USER_ZIP_CODE_LOCAL_STORAGE_KEY, countryLanguageCode);
  return localeZIPCode ? localeZIPCode.slice(0, length) : null;
}
export function getZipCode(params) {
  const { countryLanguageCode, length, detect, pattern } = params;
  let code = restoreZIPCodeValue(countryLanguageCode, length);
  if (code && !isZipCodeValid(pattern, code)) {
    removeZipCodeFromStorage();
    code = null;
  }
  isGeolocated = false;
  if (!code && detect) {
    code = getValueFromStorage(window.sessionStorage, AUTO_DETECT_ZIP_CODE_SESSION_STORAGE_KEY, AUTO_DETECT_ZIP_CODE_PROPERTY_NAME);
    if (code) {
      isGeolocated = true;
    }
  }
  return isZipCodeValid(pattern, code) ? code : null;
}
